import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { FontIcon } from 'office-ui-fabric-react/lib/Icon';
import DetailsList from '../DetailsList';
import TextButton from '../TextButton';
import Link from '../Link';
import styles from './ProductsList.style';

const columns = [
  {
    key: 'icon',
    name: 'icon',
    headerClassName: styles.iconColumnHeader,
    iconClassName: styles.headerIcon,
    arianame: 'icon',
    iconName: 'Tag',
    isIconOnly: true,
    fieldName: 'icon',
    minWidth: 8,
    maxWidth: 8,
    columnActionsMode: 0,
    onRender: () => {
      return (
        <div className={styles.iconColumn}>
          <FontIcon iconName="Tag" arianame="Tag" />
        </div>
      );
    },
  },
  {
    key: 'name',
    name: 'Product Name',
    fieldName: 'name',
    isResizable: false,
    minWidth: 100,
    maxWidth: 330,
  },
  {
    key: 'tokenID',
    name: 'Token ID',
    fieldName: 'tokenId',
    isResizable: false,
    minWidth: 100,
    maxWidth: 220,
    onRender: item => {
      return (
        <span>
          Token ID: <b className={styles.bold}>#{item.tokenId}</b>
        </span>
      );
    },
  },
];

const ProductsList = ({
  items,
  removable,
  enableView,
  onRemove,
  className: classNameProp,
  disabled,
  hideTokenId,
  ...other
}) => {
  const className = clsx(classNameProp);

  const editActions = {
    key: 'tasks',
    isResizable: false,
    minWidth: 140,
    maxWidth: 200,
    onRender: item => {
      return (
        <div className={styles.actionButtons}>
          {removable && (
            <TextButton onClick={() => onRemove(item.tokenId)} noPadding disabled={disabled}>
              Remove
            </TextButton>
          )}
          {enableView && (
            <Link className={styles.viewButton} href={item.link} target="_blank">
              View
            </Link>
          )}
        </div>
      );
    },
  };

  if (hideTokenId) {
    const tokenIdIndex = columns.findIndex(column => column.key === 'tokenID');
    columns.splice(tokenIdIndex, 1);
  }

  if (removable || enableView) {
    // Prevent this column being pushed into column array on window resize repeatedly
    const actionColumnIndex = columns.findIndex(column => column.key === 'tasks');

    if (actionColumnIndex === -1) {
      columns.push(editActions);
    } else {
      columns[actionColumnIndex] = editActions;
    }
  }

  return (
    <>
      <DetailsList
        items={items.map(product => ({
          ...product,
          key: product.tokenId || product._id,
          link: `/products/${product.tokenId}`,
        }))}
        columns={columns}
        className={className}
        {...other}
      />
    </>
  );
};

ProductsList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      tokenId: PropTypes.number,
      name: PropTypes.string,
      owner: PropTypes.string,
    }),
  ),
  removable: PropTypes.bool,
  enableView: PropTypes.bool,
  onRemove: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  hideTokenId: PropTypes.bool,
};

ProductsList.defaultProps = {
  items: [],
  removable: false,
  enableView: false,
  onRemove: null,
  className: '',
  disabled: false,
  hideTokenId: false,
};

export default ProductsList;
